export default __webpack_public_path__ + "static/media/header-lab-bubble-deploying-icon.b35bd6ea.svg";